import { Reducer } from "redux";

import { MasterNotificationTypeResponse } from "../models/api/Master";
import { MasterNotificationTypeDispatchTypes } from "../models/dispatchTypes/Master";
import { MasterNotificationTypeActionDispatchTypes } from "../constants/Master";

const initialState: MasterNotificationTypeResponse = {
  loading: false,
  response: [],
  error: null
};

const MasterNotificationTypeReducer: Reducer<
MasterNotificationTypeResponse,
MasterNotificationTypeDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterNotificationTypeActionDispatchTypes.MASTER_NOTIFICATION_TYPE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MasterNotificationTypeActionDispatchTypes.MASTER_NOTIFICATION_TYPE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
      case MasterNotificationTypeActionDispatchTypes.MASTER_NOTIFICATION_TYPE_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case MasterNotificationTypeActionDispatchTypes.MASTER_NOTIFICATION_TYPE_RESET: {
      return initialState
    }
  }
  return state;
};

export default MasterNotificationTypeReducer;
